import React, { useEffect, useRef, useState } from 'react';

import {
  Button,
  Dropdown,
  InlineErrorMessage,
  Sizes,
  TextBoldness,
  Typography,
  getClassNameFactory,
} from '@dcl/ui';

import { ModuleList } from '../../ModuleList';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { IDropdownItem, IModuleListMobileViewProps } from '../types';
import { ButtonColor, ButtonKind } from '@dcl/ui/dist/elements/Button';

const MobileView = ({
  chooseASubjectLabel,
  goToSubjectLabel,
  modulesData,
}: IModuleListMobileViewProps) => {
  const dropdownRef = useRef<Dropdown>();
  const [dropdownValue, setDropdownValue] = useState<IDropdownItem>({
    newTab: false,
    url: '',
  });
  const getClassName = getClassNameFactory(ModuleList.displayName);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const onDropdownValueChange = (value) => {
    setShowErrorMessage(false);
    setDropdownValue(value);
  };

  const onGoToButtonClick = () => {
    if (!dropdownValue.url) {
      setShowErrorMessage(true);
    } else {
      setShowErrorMessage(false);
    }
    return true;
  };
  useEffect(() => {
    dropdownRef?.current?.setState({ value: dropdownValue });
  }, [dropdownValue]);

  return (
    <div className={getClassName({ descendantName: 'mobileContainer' })}>
      <div
        className={getClassName({
          descendantName: 'dropdownContainer',
          modifiers: showErrorMessage && 'error',
        })}
      >
        <Typography
          type={Sizes.XXTRASMALL}
          boldness={TextBoldness.Medium}
          tag={TypographyTags.P}
        >
          {chooseASubjectLabel}
        </Typography>
        <Dropdown
          placeholder=""
          block={true}
          items={modulesData}
          onValueChanged={(value) => onDropdownValueChange(value)}
          withCheckmark
          value={dropdownValue}
        />
      </div>
      <div className={getClassName({ descendantName: 'error' })}>
        {showErrorMessage && (
          <InlineErrorMessage
            id={'validationError'}
            data-testid="validation-error"
            errorMessage={chooseASubjectLabel}
          />
        )}
      </div>
      <div
        className={getClassName({
          descendantName: 'buttonContainer',
          modifiers: 'mobile',
        })}
      >
        {dropdownValue.url ? (
          <Button
            kind={ButtonKind.LINK}
            color={ButtonColor.PRIMARY}
            href={dropdownValue.url}
            block={true}
            newWindow={dropdownValue.newTab}
          >
            {goToSubjectLabel}
          </Button>
        ) : (
          <Button
            kind={ButtonKind.LINK}
            color={ButtonColor.PRIMARY}
            href={dropdownValue.url}
            block={true}
            newWindow={dropdownValue.newTab}
            onClick={onGoToButtonClick}
          >
            {goToSubjectLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
export default MobileView;
